import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig from '../useGetFetchConfig';

interface ProcessingDocsResponse {
  docIds: string[];
}

export const useGetProcessingDocs = (matterId: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<ProcessingDocsResponse>(
    [QueryEntity.ProcessingDocs, { matterId }],
    () => {
      return fetch(`${APIBaseChronos}/api/matters/${matterId}/processing-docs`, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    {
      enabled: !!matterId,
      refetchInterval: 10000, // Poll every 10 seconds
      refetchOnWindowFocus: true,
    },
  );
};
